export class Subvension {
    id: string;
    nazwa = '';
    info = '';
    warunki = '';

    doplata_procent: number;
    kredyt_procent: number;
    okres: number;

    calcMonthlyRate(kwota: number): number[] {
        if (this.doplata_procent === 100 || this.okres === 0) {
            return [0, 0, 0];
        }
        const kwotaDoSplaty = kwota * (100 - this.doplata_procent) / 100;
        const rataKapitalowa = kwotaDoSplaty / (12 * this.okres);
        const odsetki = kwotaDoSplaty * this.kredyt_procent / 1200; // 12 * 100
        const rVal = [rataKapitalowa, odsetki, rataKapitalowa + odsetki];
        return rVal;
    }

    getInfo(): string {
        const str = this.info.replace(/\n/gi, '<br>');
        return str;
    }
    getWarunki(): string {
        return this.warunki.replace(/\n/gi, '<br>');
    }
}



// WEBPACK FOOTER //
// /Users/michaldudziak/Desktop/Projekty/Projekt-Sunroof/Sunroof/src/app/model/subvension.ts